import AUDITApi from './_auditApi';
import httpClient from '@/apis/base/httpclient';
class RestoreVoucherAPI extends AUDITApi {
  constructor() {
    super();
  }
  controllerName = 'RestoreVouchers';

  delete(param) {
    let request = {
      url: this.getAPIUrl(),
      data: param
    };
    return this.deleteAsync(request);
  }

  getDataById(id) {
    let request = {
      url: this.getAPIUrl() + `/${id}`
    };
    return this.getAsync(request);
  }
}

export default new RestoreVoucherAPI();
